import { useState, useEffect } from 'react'
import { auth, db } from '../../firebase'
import { collection, query, orderBy, onSnapshot } from 'firebase/firestore'

const useChats = () => {
  const [chats, setChats] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const user = auth.currentUser

  useEffect(() => {
    if (!user) { return }

    const chatsRef = collection(db, 'users', user.uid, 'chats')
    const messagesQuery = query(chatsRef, orderBy('updatedAt', 'desc'))

    const unsubscribe = onSnapshot(
      messagesQuery,
      (snapshot) => {
        const fetchedChats = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data()
        }))
        setChats(fetchedChats)
        setLoading(false)
      },
      (err) => {
        console.error('Error fetching chats: ', err)
        setError(err)
        setLoading(false)
      }
    )

    return unsubscribe
  }, [])

  return { chats, loading, error }
}

export default useChats
